import React from "react";

const IMagnifier = ({ color = "#252526", width = "16", height = "16", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M10.6667 6.75423C10.6667 4.59375 8.91463 2.84212 6.75391 2.84212C4.59318 2.84212 2.84116 4.59375 2.84115 6.75423C2.84115 8.91473 4.59317 10.6663 6.75391 10.6663C8.91464 10.6663 10.6667 8.91473 10.6667 6.75423ZM12 6.75423C12 9.65135 9.65078 11.9997 6.75391 11.9997C3.85703 11.9997 1.50781 9.65134 1.50781 6.75423C1.50783 3.85713 3.85704 1.50879 6.75391 1.50879C9.65077 1.50879 12 3.85713 12 6.75423Z"
        fill={color}
      />
      <path
        d="M14.2715 13.3285C14.5317 13.5889 14.5318 14.0109 14.2715 14.2712C14.0112 14.5315 13.5891 14.5314 13.3288 14.2712L9.52865 10.4711L10.4714 9.52838L14.2715 13.3285Z"
        fill={color}
      />
    </svg>
  );
};

export default IMagnifier;
